import { useCallback } from "react";
import useFetch from "@entrilia/shared/hooks/useFetch";
import biApi from "../../../../api/biApi";
import type { WorkbookReport } from "../../../../api/types/workbookRuns.types";

const useReportsAccessState = (reportsSettings: WorkbookReport[]) => {
  const getReportsAccessState = useCallback(
    (signal?: AbortSignal) =>
      biApi.getReportsAccessState(
        {
          reports: reportsSettings.map((report) => ({
            reportCode: report.reportCode,
            reportSource: report.reportSource,
            clientCode: report.clientCode,
            reportKind: report.reportKind,
          })),
        },
        signal
      ),
    [reportsSettings]
  );

  const [reportsAccessState, fetchReportsAccessStateError, { isFetching: isFetchingReportsAccessState }] =
    useFetch(getReportsAccessState);

  return { reportsAccessState, fetchReportsAccessStateError, isFetchingReportsAccessState };
};

export default useReportsAccessState;
